/* ══════════════════════════════════════
   My FiTT — Size Preference System
   Twisted Tailor · tt-fitt.js
   ══════════════════════════════════════ */
(function(){
  'use strict';

  var KEY = 'tt:fitt-profile';

  var OPT_MAP = {
    'jacket size':'chest','blazer size':'chest',
    'waistcoat size':'chest','waistcoats size':'chest',
    'trouser size':'waist','trousers size':'waist',
    'casual size':'casual','shirt size':'casual','size':'casual'
  };

  var BUNDLE_MAP = {
    'jacket':'chest','blazer':'chest',
    'waistcoat':'chest','waistcoats':'chest',
    'trouser':'waist','trousers':'waist'
  };

  /* ━━━ Profile ━━━ */
  var profile = {};
  try { var r = localStorage.getItem(KEY); if (r) profile = JSON.parse(r); } catch(e) {}

  function save(p)  { profile = p; try { localStorage.setItem(KEY, JSON.stringify(p)); } catch(e) {} }
  function nuke()   { profile = {}; try { localStorage.removeItem(KEY); } catch(e) {} }
  function on()     { return !!(profile.chest || profile.waist || profile.casual); }

  function tgt(dim) {
    if (dim === 'chest'  && profile.chest)  return profile.chest  + (profile.chestFit  || 'RG');
    if (dim === 'waist'  && profile.waist)  return profile.waist  + (profile.waistFit  || 'RG');
    if (dim === 'casual' && profile.casual) return profile.casual;
    return null;
  }

  /* ━━━ JSON helper (trailing commas + dedup) ━━━ */
  function pj(raw) {
    if (!raw) return null;
    try {
      var o = JSON.parse(raw.replace(/,\s*([}\]])/g, '$1'));
      for (var k in o) if (o.hasOwnProperty(k) && Array.isArray(o[k]))
        o[k] = o[k].filter(function(v,i,a){ return v && a.indexOf(v) === i; });
      return o;
    } catch(e) { return null; }
  }

  /* ━━━ Card match ━━━ */
  function matches(card) {
    if (!on()) return true;

    var opts = pj(card.getAttribute('data-available-options'));
    if (!opts) return true;
    for (var name in opts) {
      if (!opts.hasOwnProperty(name)) continue;
      var d = OPT_MAP[name.toLowerCase()];
      if (!d) continue;
      var t = tgt(d);
      if (!t) continue;
      if (opts[name].indexOf(t) === -1) return false;
    }
    return true;
  }

  /* ━━━ Drawer ━━━ */
  var drawer = document.querySelector('[data-fitt]');
  var form   = document.querySelector('[data-fitt-form]');

  function openDrawer() {
    if (!drawer) return;
    restorePills();
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    /* closing the drawer counts as dismissing the nudge */
    setNudgeDismissed();
  }

  /* Pill clicks */
  if (drawer) drawer.addEventListener('click', function(e) {
    var pill = e.target.closest('.fitt__pill');
    if (!pill) return;
    var ctr = pill.closest('[data-fitt-pills]');
    if (!ctr) return;
    var g = ctr.dataset.fittPills;
    var isFit = (g === 'chestFit' || g === 'waistFit');

    if (isFit) {
      ctr.querySelectorAll('.fitt__pill').forEach(function(p){ p.classList.remove('fitt__pill--on'); });
      pill.classList.add('fitt__pill--on');
    } else {
      var was = pill.classList.contains('fitt__pill--on');
      ctr.querySelectorAll('.fitt__pill').forEach(function(p){ p.classList.remove('fitt__pill--on'); });
      if (!was) pill.classList.add('fitt__pill--on');
    }
  });

  /* Close / open delegated */
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-fitt-close]'))   closeDrawer();
    if (e.target.closest('[data-fitt-trigger]') || e.target.closest('[data-fitt-open]')) { e.preventDefault(); openDrawer(); }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
  });

  /* Form submit */
  if (form) form.addEventListener('submit', function(e) {
    e.preventDefault();
    var p = {};
    function sel(g) { var el = form.querySelector('[data-fitt-pills="'+g+'"] .fitt__pill--on'); return el ? el.dataset.val : null; }
    if (sel('chest'))    p.chest    = sel('chest');
    if (sel('chestFit')) p.chestFit = sel('chestFit');
    if (sel('waist'))    p.waist    = sel('waist');
    if (sel('waistFit')) p.waistFit = sel('waistFit');
    if (sel('casual'))   p.casual   = sel('casual');
    save(p);
    closeDrawer();
    applyAll();
  });

  /* Clear */
  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-fitt-clear]')) return;
    nuke();
    restorePills();
    closeDrawer();
    applyAll();
  });

  /* Restore pill state */
  function restorePills() {
    if (!drawer) return;
    drawer.querySelectorAll('.fitt__pill--on').forEach(function(p){ p.classList.remove('fitt__pill--on'); });
    ['chest','waist','casual'].forEach(function(k) {
      if (!profile[k]) return;
      var el = drawer.querySelector('[data-fitt-pills="'+k+'"] .fitt__pill[data-val="'+profile[k]+'"]');
      if (el) el.classList.add('fitt__pill--on');
    });
    ['chestFit','waistFit'].forEach(function(k) {
      var v = profile[k] || 'RG';
      var el = drawer.querySelector('[data-fitt-pills="'+k+'"] .fitt__pill[data-val="'+v+'"]');
      if (el) el.classList.add('fitt__pill--on');
    });
    var cb = drawer.querySelector('[data-fitt-clear]');
    if (cb) cb.style.display = on() ? '' : 'none';
  }

  /* ━━━ Header ━━━ */
  function updateHeader() {
    document.querySelectorAll('[data-fitt-trigger]').forEach(function(b) {
      b.classList.toggle('tt-hdr__fitt--active', on());
    });
  }

  /* ━━━ Collection badges ━━━ */
  function filterCollection() {
    var grid = document.querySelector('[data-cl-grid]');
    if (!grid) return;

    var old = document.querySelector('[data-fitt-banner]');
    if (old) old.remove();
    grid.querySelectorAll('.fitt-badge').forEach(function(el){ el.remove(); });

    if (!on()) return;

    var items = grid.querySelectorAll('.cl__item');
    var matched = 0;
    items.forEach(function(item) {
      var card = item.querySelector('[data-product-card]');
      if (!card) return;
      if (matches(card)) {
        matched++;
        var media = card.querySelector('.pc__media');
        if (media && !media.querySelector('.fitt-badge')) {
          var b = document.createElement('span');
          b.className = 'fitt-badge';
          b.innerHTML = '<svg width="16" height="16" viewBox="0 0 20 20" fill="none"><rect x="3" y="6" width="14" height="8" rx="1" stroke="#fff" stroke-width="1.5"/><path d="M6 6v3M9 6v4M12 6v3M15 6v3" stroke="#fff" stroke-width="1.2" stroke-linecap="round"/></svg>';
          media.appendChild(b);
        }
      }
    });

    if (matched > 0) {
      var head = document.querySelector('.cl__head');
      if (head) {
        var el = document.createElement('div');
        el.className = 'fitt-banner';
        el.setAttribute('data-fitt-banner', '');
        el.innerHTML =
          '<span class="fitt-banner__text">' +
            'My Fi<span class="fitt__tt">TT</span> is active — <strong>' + matched + '</strong> products available in your size' +
          '</span>' +
          '<span class="fitt-banner__actions">' +
            '<button type="button" class="fitt-banner__link" data-fitt-open>Change</button>' +
          '</span>';
        head.after(el);
      }
    }
  }

  /* ━━━ PDP pre-selection ━━━ */
  function preselectPDP() {
    var sec = document.querySelector('.pp__section');
    if (!sec || !on()) return;
    if (window.location.search.indexOf('variant=') > -1) return;

    var didSelect = false;
    var firstSizeSection = null;
    var fittIcon = '<svg class="pp__dd-fitt-icon" viewBox="0 0 20 20" fill="none"><rect x="3" y="6" width="14" height="8" rx="1" stroke="currentColor" stroke-width="1.5"/><path d="M6 6v3M9 6v4M12 6v3M15 6v3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>';

    function markFitt(container, value, bySize) {
      container.querySelectorAll('[data-dd-option]').forEach(function(ddOpt) {
        var v = bySize ? (ddOpt.dataset.ddSize || '').trim() : (ddOpt.dataset.ddValue || '').trim();
        if (v === value && !ddOpt.querySelector('.pp__dd-fitt-icon')) {
          ddOpt.insertAdjacentHTML('beforeend', fittIcon);
        }
      });
    }

    /* Standard options — custom dropdowns */
    sec.querySelectorAll('.pp__size-section[data-option-index]').forEach(function(wrap) {
      var lbl = wrap.querySelector('.pp__label');
      if (!lbl) return;
      var d = OPT_MAP[lbl.textContent.trim().toLowerCase()];
      if (!d) return;
      var t = tgt(d);
      if (!t) return;
      if (!firstSizeSection) firstSizeSection = wrap;

      markFitt(wrap, t, false);

      var sel = wrap.querySelector('[data-option-select]');
      if (!sel) return;
      for (var i = 0; i < sel.options.length; i++) {
        var optText = sel.options[i].text.trim().replace(/ — Out Of Stock$/, '');
        if (optText === t && !sel.options[i].classList.contains('pp__select--oos')) {
          sel.selectedIndex = i;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          didSelect = true;
          break;
        }
      }
    });

    /* Suit pickers — custom dropdowns */
    sec.querySelectorAll('[data-suit-picker]').forEach(function(picker) {
      var lbl = picker.querySelector('.pp__label');
      if (!lbl) return;
      var d = OPT_MAP[lbl.textContent.trim().toLowerCase()];
      if (!d) return;
      var t = tgt(d);
      if (!t) return;
      if (!firstSizeSection) firstSizeSection = picker;

      markFitt(picker, t, true);

      var sel = picker.querySelector('[data-suit-select]');
      if (!sel) return;
      for (var i = 0; i < sel.options.length; i++) {
        var optText = sel.options[i].text.trim().replace(/ — Out Of Stock$/, '');
        if (optText === t && !sel.options[i].classList.contains('pp__select--oos')) {
          sel.selectedIndex = i;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          didSelect = true;
          break;
        }
      }
    });

    /* Upsell selects */
    sec.querySelectorAll('[data-upsell-variant]').forEach(function(sel) {
      var up = sel.closest('[data-upsell]');
      if (!up) return;
      var lbl = up.querySelector('.pp__carrier-label');
      if (!lbl) return;
      var txt = lbl.textContent.trim().toLowerCase();
      var d = null;
      if (txt.indexOf('jacket') > -1 || txt.indexOf('waistcoat') > -1 || txt.indexOf('blazer') > -1) d = 'chest';
      else if (txt.indexOf('trouser') > -1) d = 'waist';
      if (!d) return;
      var t = tgt(d);
      if (!t) return;

      /* Mark FiTT icon on the matching custom dropdown option */
      var ddPanel = up.querySelector('[data-dd-panel]');
      if (ddPanel) {
        ddPanel.querySelectorAll('[data-dd-option]').forEach(function(ddOpt) {
          var optLabel = ddOpt.querySelector('.pp__dd-opt-label');
          if (!optLabel) return;
          var optText = optLabel.textContent.trim().replace(/ – Out of stock.*/, '');
          if (optText === t && !ddOpt.querySelector('.pp__dd-fitt-icon')) {
            ddOpt.insertAdjacentHTML('beforeend', fittIcon);
          }
        });
      }

      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].text.trim() === t && !sel.options[i].disabled) {
          sel.value = sel.options[i].value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    });

    /* PDP notification */
    if (didSelect && firstSizeSection && !sec.querySelector('[data-fitt-note]')) {
      var note = document.createElement('div');
      note.className = 'fitt-note';
      note.setAttribute('data-fitt-note', '');

      var sgBtn = sec.querySelector('[data-open-size-guide]');
      var sgHtml = sgBtn
        ? ' Double check against our <button type="button" class="fitt-note__link" data-fitt-sg>size guide</button>.'
        : '';

      note.innerHTML =
        '<span class="fitt-note__text">' +
          'We’ve pre-selected your MyFi<span class="fitt__tt">TT</span> size.' + sgHtml +
        '</span>' +
        '<span class="fitt-note__actions">' +
          '<button type="button" class="fitt-note__link" data-fitt-open>Change</button>' +
          '<button type="button" class="fitt-note__close" data-fitt-note-close aria-label="Close">&times;</button>' +
        '</span>';

      firstSizeSection.before(note);

      /* Size guide trigger */
      var sgLink = note.querySelector('[data-fitt-sg]');
      if (sgLink && sgBtn) sgLink.addEventListener('click', function() { sgBtn.click(); });

      /* Close button */
      note.querySelector('[data-fitt-note-close]').addEventListener('click', function() { note.remove(); });

      /* Auto-dismiss on manual size pick */
      sec.addEventListener('click', function dismiss(e) {
        if (e.target.closest('.pp__size-btn') && sec.querySelector('[data-fitt-note]')) {
          note.remove();
          sec.removeEventListener('click', dismiss);
        }
      });
    }
  }

  function dot(btn) {
    btn.classList.add('pp__size-btn--fitt');
    if (!btn.querySelector('.fitt-dot')) {
      var d = document.createElement('span');
      d.className = 'fitt-dot';
      btn.appendChild(d);
    }
  }

  /* ━━━ Apply ━━━ */
  function applyAll() {
    updateHeader();
    filterCollection();
    preselectPDP();
  }

  /* ━━━ MutationObserver — re-badge after AJAX collection reload ━━━ */
  var grid = document.querySelector('[data-cl-grid]');
  if (grid) {
    new MutationObserver(function() {
      if (on()) setTimeout(filterCollection, 20);
    }).observe(grid, { childList: true });
  }

  /* ━━━ Public API ━━━ */
  window.TT = window.TT || {};
  window.TT.Fitt = {
    open:    openDrawer,
    close:   closeDrawer,
    profile: function(){ return JSON.parse(JSON.stringify(profile)); },
    active:  on,
    apply:   applyAll,
    matches: matches
  };

  /* ━━━ Nudge toast ━━━ */
  var NUDGE_KEY = 'tt:fitt-nudged';
  var NUDGE_DAYS = 60;

  function nudgeDismissed() {
    var v = null;
    try { v = localStorage.getItem(NUDGE_KEY); } catch(e) {}
    if (!v) {
      var m = document.cookie.match(/(?:^|; )tt_fitt_nudged=([^;]*)/);
      if (m) v = m[1];
    }
    if (!v) return false;
    if (v === '1') return true; /* legacy permanent flag */
    var ts = parseInt(v, 10);
    if (!ts) return true;
    return (Date.now() - ts) < NUDGE_DAYS * 24 * 60 * 60 * 1000;
  }

  function setNudgeDismissed() {
    var now = String(Date.now());
    try { localStorage.setItem(NUDGE_KEY, now); } catch(e) {}
    try { document.cookie = 'tt_fitt_nudged=' + now + '; path=/; max-age=' + (NUDGE_DAYS * 24 * 60 * 60) + '; SameSite=Lax'; } catch(e) {}
  }

  function showNudge() {
    if (on()) return;
    if (nudgeDismissed()) return;

    var toast = document.createElement('div');
    toast.className = 'fitt-toast';
    toast.innerHTML =
      '<svg class="fitt-toast__icon" viewBox="0 0 20 20" fill="none"><rect x="3" y="6" width="14" height="8" rx="1" stroke="currentColor" stroke-width="1.5"/><path d="M6 6v3M9 6v4M12 6v3M15 6v3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>' +
      '<span class="fitt-toast__text">Know your size? <strong>Set your fit preferences</strong> for a personalised experience.</span>' +
      '<button type="button" class="fitt-toast__cta" data-fitt-open>Set My Fi<span class="fitt__tt" style="color:#fff">TT</span></button>' +
      '<button type="button" class="fitt-toast__close" aria-label="Dismiss">&times;</button>';
    document.body.appendChild(toast);

    function dismiss() {
      toast.classList.remove('fitt-toast--visible');
      setNudgeDismissed();
      setTimeout(function() { toast.remove(); }, 400);
    }

    toast.querySelector('.fitt-toast__close').addEventListener('click', dismiss);
    toast.querySelector('.fitt-toast__cta').addEventListener('click', function() {
      dismiss();
      openDrawer();
    });

    requestAnimationFrame(function() {
      requestAnimationFrame(function() { toast.classList.add('fitt-toast--visible'); });
    });
  }

  /* ━━━ Init ━━━ */
  if (document.readyState !== 'loading') applyAll();
  else document.addEventListener('DOMContentLoaded', applyAll);

  setTimeout(showNudge, 20000);

})();

